import Logo from "../Logo/Logo";
import "./Footer.css"
import { Link } from "react-router-dom";

function Footer() {
    return ( 
        <footer>
            <div className="footer-container">

            <div className="footer-brand">
                <div className="footer-logo">
                    <Logo/>
                </div>       
                <p className="footer-tagline">
                    Wir verschaffen Ihnen einen glänzenden Auftritt.
                </p>
            </div>

            <div className="footer-links">
                <div>
                    <h4>Fit2Clean</h4>
                    <Link to="/home">Startseite</Link>
                    <Link to="/services">Leistungen</Link>
                    <Link to="/about-us">Über uns</Link>
                </div>

                <div>
                    <h4>Rechtliches</h4>
                    <Link to="/impressum">Impressum</Link>
                    <Link to="/haftungsausschluss">Haftungsausschluss</Link>
                    <Link to="/datenschutz">Datenschutz</Link>
                    <Link to="/cookies">Cookies</Link>
                    <Link to="/AGB">Allgemeine Geschäftsbedingungen</Link> 
                    <Link to="/links">Links</Link>
                </div>
            </div>

               <div className="footer-bottom">
                    <p>© {new Date().getFullYear()} Fit2Clean</p>
                </div>

            </div>
        </footer>
    );
}

export default Footer;